function aiArtCustomizer() {
  return {
    formData: {
      childName: '',
      communionDate: '',
      textStyle: 'soft',
      textSize: 50,
      textHeight: 50
    },

    // 只有这一份逻辑，改起来绝对安全，不会触碰裁剪代码
    submitArtwork() {
      // 这里的 this.croppedImageUrl 是从 aiUploadHandler 自动继承来的
      const finalPayload = {
        image: this.croppedImageUrl, 
        ...this.formData
      };
      console.log("最终提交数据:", finalPayload);
      // 调用 API...
    }
  }
}